
import VueSlickCarousel from "vue-slick-carousel";
import "vue-slick-carousel/dist/vue-slick-carousel.css";

export default {
  components: { VueSlickCarousel },
  data() {
    return {
      filterOpen: false,
      queryItems: [],
      showChecbox: false,
      geoPositions: [],
      allProducts: [],
      filterSimilarCapacity: false,
      settings: {
        infinite: true,
        slidesToShow: 1,
        arrows: true,
        dots: false,
        speed: 500,
      },

      options: [
        {
          name: "locationCoordinates",
          label: "Coordinates",
          type: "coordinates",
        },
        {
          name: "itemName",
          label: "Item name",
          type: "text",
        },
        {
          name: "itemAddress",
          label: "Item address",
          type: "text",
        },
        {
          name: "city",
          label: "City",
          type: "text",
        },
        {
          name: "price",
          label: "Price",
          type: "text",
        },
        {
          name: "capacity",
          label: "Capacity",
          type: "text",
        },
        {
          name: "media",
          label: "Media",
          type: "text",
        },
      ],
    };
  },

  beforeMount() {
    this.$nextTick(() => {
      const body = document.documentElement;
      body.classList.add("product-list-page");
    });
  },

  mounted() {
    if (
      this.$refs.controllerProducts &&
      this.$refs.controllerProducts.options
    ) {
      this.$refs.controllerProducts.options.sort = "Najviše prioritetni";
      this.$refs.controllerProducts.fetchData();
    }

    this.$watch(
      () => {
        return this.$refs.controllerProducts?.options?.page;
      },
      (val) => {
        this.$router.push({ query: { page: val } });
        this.getGeoPositions();
      }
    );

    if (this.$route && this.$route.query && this.$route.query.page) {
      if (
        this.$refs.controllerProducts &&
        this.$refs.controllerProducts.options &&
        this.$refs.controllerProducts.options.page
      ) {
        this.$refs.controllerProducts.options.page = parseInt(
          this.$route.query.page
        );
      }
    }

    this.getGeoPositions();
  },

  destroyed() {
    const body = document.documentElement;
    body.classList.remove("product-list-page");
  },

  methods: {
    toggleFilterModal() {
      this.filterOpen = !this.filterOpen;
    },
    closeFilterModal() {
      this.filterOpen = false;
    },

    showSimilarCapacityChecbox() {
      this.showChecbox = true;
    },

    async getGeoPositions() {
      await this.$refs.controllerProducts?.fetchData();

      if (
        this.$refs.controllerProducts &&
        this.$refs.controllerProducts.items &&
        this.$refs.controllerProducts.items.length
      ) {
        this.geoPositions = [];
        const products = this.$refs.controllerProducts.items;

        products.forEach((product) => {
          if (
            product.attributes &&
            Object.entries(product.attributes).length > 0
          ) {
            const productAttributes = product.attributes;
            let lat, long, itemName, itemAddress, city, capacity, price;

            Object.entries(productAttributes).forEach(([key, att]) => {
              if (key === "att_latitude_textField" && att) {
                lat = att;
              }
              if (key === "att_longitude_textField" && att) {
                long = att;
              }

              if (key === "att_broj-osoba_numberField") {
                capacity = att;
              }
              if (key === "att_adresa-objekta_textField") {
                itemAddress = att;
              }
              if (key === "att_grad_textField") {
                city = att;
              }
            });

            price = product.retailPrice;
            itemName = `${this.$t("text.apartmentFor")}${capacity} ${
              capacity === 1 ? this.$t("text.worker") : this.$t("text.workers")
            } - ${city}`;

            if (lat && long) {
              if (typeof lat === "string" && typeof long === "string") {
                lat = lat.replace(",", ".");
                long = long.replace(",", ".");
              }

              this.geoPositions.push({
                $id: product.id,
                locationCoordinates: {
                  lat: lat,
                  long: long,
                },
                itemName: itemName,
                itemAddress: itemAddress,
                capacity: capacity,
                city: city,
                price: price,
                media: product.media,
                slug: product.slug
              });
            }
          }
        });

        this.setGeoPositionsOnMap();
      }
    },

    goToProduct(item, event) {
      this.$router.push(`/product/${item.slug}`);
    },

    setGeoPositionsOnMap() {
      this.$refs.map.markers = [];
      this.$refs.list.items = [];

      if (this.geoPositions && this.geoPositions.length && this.$refs.list) {
        var markers = [];

        this.geoPositions.forEach((position) => {
          this.$refs.list.items.push(position);
          var geoLat = position.locationCoordinates?.lat;
          var geoLong = position.locationCoordinates?.long;
          var itemName = position.itemName;
          var itemAddress = position.itemAddress;
          var price = position.price;
          var city = position.city;
          var capacity = position.capacity;
          var media = position.media;
          const slug = position.slug;
          if (typeof geoLat === "string" && typeof geoLong === "string") {
            geoLat = geoLat.replace(",", ".");
            geoLong = geoLong.replace(",", ".");
          }

          markers.push({
            coordinates: [Number(geoLat), Number(geoLong)],
            popupItem: {
              $id: position.$id,
              locationCoordinates: {
                lat: geoLat,
                long: geoLong,
              },
              itemName: itemName,
              itemAddress: itemAddress,
              city: city,
              price: price,
              capacity: capacity,
              media: media,
              slug: slug
            },
          });
        });

        setTimeout(() => {
          this.$refs.map.markers = markers;
        }, 500);
      }
    },
  },
};
